export const background = -10;

export const overlap = 5;

export const header = 10;

export const popover = 20;

const zIndicies = {
  background,
  overlap,
  header,
  popover,
};

export default zIndicies;
